// Client-side sorting and pagination for property reviews
(function () {
  
    var REVIEWS_PER_PAGE = 10;
    var currentPage = 1;

    var list = document.querySelector('.reviews-list');
    if (!list) return;

    var pag = document.querySelector('.reviews-pagination');
    var pagUl = pag.querySelector('ul');
    var sortSelect = document.getElementById('reviews-sort');

    var items = Array.prototype.slice.call(list.children).map(function (el) {
        return {
            el: el,
            date: new Date(el.getAttribute('data-date')).getTime(),
            rating: parseFloat(el.getAttribute('data-rating'))
        };
    });

    var sortedItems = items.slice();

    var comparators = {
        newest: function (a, b) { return b.date - a.date; },
        oldest: function (a, b) { return a.date - b.date; },
        best:   function (a, b) { return b.rating - a.rating; },
        worst:  function (a, b) { return a.rating - b.rating; }
    };

    function sortReviews(method) {
        sortedItems = items.slice();
        if (comparators[method]) {
            sortedItems.sort(comparators[method]);
        }
        currentPage = 1;
        renderPage();
    }

    function renderPage() {
        var totalPages = Math.ceil(sortedItems.length / REVIEWS_PER_PAGE);
        var start = (currentPage - 1) * REVIEWS_PER_PAGE;
        var end = Math.min(start + REVIEWS_PER_PAGE, sortedItems.length);

        list.innerHTML = '';
        for (var i = start; i < end; i++) {
            list.appendChild(sortedItems[i].el);
        }

        renderPagination(totalPages);
    }

    function renderPagination(totalPages) {
        if (totalPages <= 1) { pag.style.display = 'none'; return; }
        pag.style.display = '';

        var html = '<li' + (currentPage === 1 ? ' class="disabled"' : '') + '><a href="#reviews-view" data-page="' + Math.max(1, currentPage - 1) + '">&lsaquo;</a></li>';
        for (var i = 1; i <= totalPages; i++) {
            html += '<li' + (i === currentPage ? ' class="current"' : '') + '><a href="#reviews-view" data-page="' + i + '">' + i + '</a></li>';
        }
        html += '<li' + (currentPage === totalPages ? ' class="disabled"' : '') + '><a href="#reviews-view" data-page="' + Math.min(totalPages, currentPage + 1) + '">&rsaquo;</a></li>';

        pagUl.innerHTML = html;
    }

    document.addEventListener('click', function (e) {
        var link = e.target.closest('.reviews-pagination a');
        if (!link) return;
        e.preventDefault();
        var page = parseInt(link.getAttribute('data-page'), 10);
        if (page !== currentPage) {
            currentPage = page;
            renderPage();
            document.getElementById('reviews-view').scrollIntoView({ behavior: 'smooth' });
        }
    });

    sortSelect.addEventListener('change', function () {
        sortReviews(this.value);
    });

    sortReviews('newest');
})();